import React from "react";
import { useLocalization } from "@fluent/react";
import { ContextForm, TaxIDTextInput, validateTaxID } from "cerulean";
import useRevalidateErroringField from "../hooks/useRevalidateErroringField";

type EinFieldProps = {
  revalidateErrorsOnBlur?: boolean;
};

const EinField = ({ revalidateErrorsOnBlur = false }: EinFieldProps) => {
  const { l10n } = useLocalization();
  const field = "ein";
  const revalidateErroringField = useRevalidateErroringField(field);

  return (
    <ContextForm.Field required validate={validateTaxID} key={field}>
      <TaxIDTextInput
        ein
        field={field}
        label={l10n.getString("label-tax-id", null, "EIN/Tax ID")}
        onBlur={revalidateErrorsOnBlur ? revalidateErroringField : undefined}
      />
    </ContextForm.Field>
  );
};

export default EinField;
